/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Reviews_DeleteInputs */

const he_account_reviews_delete = /** @type {(inputs: Account_Reviews_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מחק ביקורת`)
};

const en_account_reviews_delete = /** @type {(inputs: Account_Reviews_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete review`)
};

/**
* | output |
* | --- |
* | "Delete review" |
*
* @param {Account_Reviews_DeleteInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_reviews_delete = /** @type {((inputs?: Account_Reviews_DeleteInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Reviews_DeleteInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_reviews_delete(inputs)
	return en_account_reviews_delete(inputs)
});